import { TechnologyProp } from "models/UI/Technologies/TechnologyProp";
import classes from './TechnologyImage.module.scss';

const TechnologyImage: React.FC<TechnologyProp> = ({title, image}) => {
    return <div className={classes['wrapper-image-technology']}>
        <img src={image} alt={title} loading="lazy" />
    </div>
}

export default TechnologyImage;